import React, { lazy } from 'react';
import { Instagram, Facebook, MapPin, Clock, Phone, Mail, Map as MapIcon } from 'lucide-react';
import { WhatsAppIcon, TikTokIcon } from './Icons';
import { FadeIn } from './FadeIn';
export function BookingCTA() {
  return <section id="booking" className="bg-black text-center py-[120px] px-[25px] md:px-[60px] relative overflow-hidden" data-id="element-54">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(201,168,76,0.06)_0%,transparent_70%)] pointer-events-none" data-id="element-55"></div>

      <FadeIn className="relative z-10" data-id="element-56">
        <div className="inline-block text-[0.65rem] tracking-[6px] uppercase text-gold border border-gold/30 py-2 px-6 mb-[30px] font-semibold" data-id="element-57">
          Agenda Tu Sesión
        </div>
        <h2 className="font-cinzel text-[clamp(2rem,5vw,4rem)] text-white uppercase tracking-[5px] mb-5" data-id="element-58">
          ¿Listo Para Tu
          <br data-id="element-59" />
          <span className="text-gold" data-id="element-60">Próxima Obra?</span>
        </h2>
        <p className="text-gray text-[1rem] leading-[1.8] max-w-[550px] mx-auto mb-[50px]" data-id="element-61">
          El primer paso es una consulta. Cuéntanos tu idea, exploramos el
          diseño juntos y creamos algo que llevarás con orgullo para siempre.
        </p>

        <div className="flex gap-5 justify-center flex-wrap mb-[40px]" data-id="element-62">
          <a href="https://www.instagram.com/solido_tattoo_studio?igsh=MXV4eDlrM3g1ZGoyeA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-dark-2 border border-gold/20 p-[18px_28px] transition-all duration-300 text-white hover:border-gold hover:bg-gold/5 hover:-translate-y-1" data-id="element-63">
            <Instagram className="text-gold" size={24} data-id="element-64" />
            <div className="text-left" data-id="element-65">
              <span className="text-[0.6rem] tracking-[3px] uppercase text-gray block" data-id="element-66">
                Escríbenos por
              </span>
              <span className="font-cinzel text-[0.85rem] text-white tracking-[2px]" data-id="element-67">
                Instagram
              </span>
            </div>
          </a>
          <a href="http://wa.me/15615275756" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 bg-dark-2 border border-gold/20 p-[18px_28px] transition-all duration-300 text-white hover:border-gold hover:bg-gold/5 hover:-translate-y-1" data-id="element-68">
            <WhatsAppIcon className="text-gold w-6 h-6" data-id="element-69" />
            <div className="text-left" data-id="element-70">
              <span className="text-[0.6rem] tracking-[3px] uppercase text-gray block" data-id="element-71">
                Escríbenos por
              </span>
              <span className="font-cinzel text-[0.85rem] text-white tracking-[2px]" data-id="element-72">
                WhatsApp
              </span>
            </div>
          </a>
          <a href="#" className="flex items-center gap-3 bg-dark-2 border border-gold/20 p-[18px_28px] transition-all duration-300 text-white hover:border-gold hover:bg-gold/5 hover:-translate-y-1" data-id="element-73">
            <Facebook className="text-gold" size={24} data-id="element-74" />
            <div className="text-left" data-id="element-75">
              <span className="text-[0.6rem] tracking-[3px] uppercase text-gray block" data-id="element-76">
                Escríbenos por
              </span>
              <span className="font-cinzel text-[0.85rem] text-white tracking-[2px]" data-id="element-77">
                Facebook
              </span>
            </div>
          </a>
        </div>

        <a href="https://www.google.com/maps/search/?api=1&query=8150+SW+8th+St+Suite+205+Miami+FL+33144" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent text-white py-4 px-10 font-cinzel text-[0.75rem] font-bold tracking-[4px] uppercase border border-white/20 transition-all duration-300 hover:border-gold hover:text-gold hover:-translate-y-0.5" data-id="element-78">
          Ver Ubicación del Estudio
        </a>
      </FadeIn>
    </section>;
}
export function SocialLinks() {
  return <section id="social" className="bg-dark text-center py-[80px] px-[25px] md:px-[60px]" data-id="element-79">
      <FadeIn data-id="element-80">
        <span className="inline-block text-[0.6rem] tracking-[6px] uppercase text-gold mb-[15px] font-semibold" data-id="element-81">
          Síguenos
        </span>
        <h2 className="font-cinzel text-[clamp(1.8rem,4vw,3rem)] text-white uppercase tracking-[4px] mb-5" data-id="element-82">
          Nuestras <span className="text-gold" data-id="element-83">Redes</span>
        </h2>
        <div className="w-[60px] h-[2px] bg-gold mx-auto mb-5" data-id="element-84"></div>
        <p className="text-gray text-[0.95rem] leading-[1.8] max-w-[600px] mx-auto tracking-[0.5px]" data-id="element-85">
          Sigue nuestro trabajo diario, inspírate con los últimos tatuajes y sé
          el primero en enterarte de disponibilidad.
        </p>

        <div className="flex justify-center gap-[25px] mt-[40px]" data-id="element-86">
          <div className="flex flex-col items-center gap-1.5" data-id="element-87">
            <a href="https://www.instagram.com/solido_tattoo_studio?igsh=MXV4eDlrM3g1ZGoyeA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-[60px] h-[60px] border border-gold/20 flex items-center justify-center text-gold transition-all duration-300 hover:bg-gold hover:text-black hover:border-gold hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(201,168,76,0.3)]" data-id="element-88">
              <Instagram size={24} data-id="element-89" />
            </a>
            <span className="text-[0.7rem] tracking-[3px] uppercase text-gray mt-2.5 block" data-id="element-90">
              Instagram
            </span>
          </div>
          <div className="flex flex-col items-center gap-1.5" data-id="element-91">
            <a href="#" className="w-[60px] h-[60px] border border-gold/20 flex items-center justify-center text-gold transition-all duration-300 hover:bg-gold hover:text-black hover:border-gold hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(201,168,76,0.3)]" data-id="element-92">
              <Facebook size={24} data-id="element-93" />
            </a>
            <span className="text-[0.7rem] tracking-[3px] uppercase text-gray mt-2.5 block" data-id="element-94">
              Facebook
            </span>
          </div>
          <div className="flex flex-col items-center gap-1.5" data-id="element-95">
            <a href="#" className="w-[60px] h-[60px] border border-gold/20 flex items-center justify-center text-gold transition-all duration-300 hover:bg-gold hover:text-black hover:border-gold hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(201,168,76,0.3)]" data-id="element-96">
              <TikTokIcon className="w-6 h-6" data-id="element-97" />
            </a>
            <span className="text-[0.7rem] tracking-[3px] uppercase text-gray mt-2.5 block" data-id="element-98">
              TikTok
            </span>
          </div>
        </div>
      </FadeIn>
    </section>;
}
export function MapSection() {
  return <section id="map-section" className="py-[70px] px-[25px] md:py-[80px] md:px-[40px] lg:py-[100px] lg:px-[60px] bg-black" data-id="element-99">
      <div className="max-w-[1200px] mx-auto" data-id="element-100">
        <FadeIn className="text-center mb-[70px]" data-id="element-101">
          <span className="inline-block text-[0.6rem] tracking-[6px] uppercase text-gold mb-[15px] font-semibold" data-id="element-102">
            Encuéntranos
          </span>
          <h2 className="font-cinzel text-[clamp(1.8rem,4vw,3rem)] text-white uppercase tracking-[4px] mb-5" data-id="element-103">
            Visítanos en <span className="text-gold" data-id="element-104">Miami</span>
          </h2>
          <div className="w-[60px] h-[2px] bg-gold mx-auto mb-5" data-id="element-105"></div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-[40px] items-start" data-id="element-106">
          <FadeIn className="bg-dark-2 border border-gold/10 p-[40px_30px]" data-id="element-107">
            <div className="text-[1.2rem] text-gold uppercase tracking-[3px] mb-[30px] pb-[20px] border-b border-gold/20 flex items-center gap-2.5" data-id="element-108">
              <MapPin size={20} data-id="element-109" />
              Información
            </div>

            <div className="flex gap-[15px] mb-[25px] items-start" data-id="element-110">
              <MapPin size={16} className="text-gold mt-1 shrink-0" data-id="element-111" />
              <div data-id="element-112">
                <span className="text-[0.6rem] tracking-[3px] uppercase text-gold block mb-1 font-semibold" data-id="element-113">
                  Dirección
                </span>
                <span className="text-[0.9rem] text-white leading-[1.5]" data-id="element-114">
                  SOLIDO TATTOO STUDIO
                  <br data-id="element-115" />
                  8150 SW 8th St, Suite 205
                  <br data-id="element-116" />
                  Miami, FL 33144
                </span>
              </div>
            </div>

            <div className="flex gap-[15px] mb-[25px] items-start" data-id="element-117">
              <Clock size={16} className="text-gold mt-1 shrink-0" data-id="element-118" />
              <div data-id="element-119">
                <span className="text-[0.6rem] tracking-[3px] uppercase text-gold block mb-1 font-semibold" data-id="element-120">
                  Horario
                </span>
                <span className="text-[0.9rem] text-white leading-[1.5]" data-id="element-121">
                  Lun – Dom: 11:00 AM – 9:00 PM
                </span>
              </div>
            </div>

            <div className="flex gap-[15px] mb-[25px] items-start" data-id="element-122">
              <Phone size={16} className="text-gold mt-1 shrink-0" data-id="element-123" />
              <div data-id="element-124">
                <span className="text-[0.6rem] tracking-[3px] uppercase text-gold block mb-1 font-semibold" data-id="element-125">
                  Teléfono / WhatsApp
                </span>
                <span className="text-[0.9rem] text-white leading-[1.5]" data-id="element-126">
                  +1 (561) 5275756
                </span>
              </div>
            </div>

            <div className="flex gap-[15px] mb-[25px] items-start" data-id="element-127">
              <Mail size={16} className="text-gold mt-1 shrink-0" data-id="element-128" />
              <div data-id="element-129">
                <span className="text-[0.6rem] tracking-[3px] uppercase text-gold block mb-1 font-semibold" data-id="element-130">
                  Email
                </span>
                <span className="text-[0.9rem] text-white leading-[1.5]" data-id="element-131">
                  solidotattoostudio@gmail.com
                </span>
              </div>
            </div>

            <a href="#booking" className="block text-center mt-[20px] bg-gold text-black py-4 px-10 font-cinzel text-[0.75rem] font-bold tracking-[4px] uppercase relative overflow-hidden group transition-all duration-300 hover:bg-gold-light hover:-translate-y-0.5 hover:shadow-[0_10px_40px_rgba(201,168,76,0.4)]" data-id="element-132">
              <span className="absolute top-0 -left-full w-full h-full bg-white/20 transition-all duration-300 group-hover:left-full" data-id="element-133"></span>
              Agenda Tu Cita
            </a>
          </FadeIn>

          <FadeIn className="h-[350px] lg:h-[420px] border border-gold/10 overflow-hidden relative" data-id="element-134">
            <iframe src="https://www.google.com/maps?q=8150+SW+8th+St+Suite+205,+Miami,+FL+33144&output=embed&z=16" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="SOLIDO TATTOO STUDIO - 8150 SW 8th St Suite 205, Miami, FL 33144" className="w-full h-full" data-id="element-135" />
          </FadeIn>
        </div>
      </div>
    </section>;
}